import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import '@/assets/tailwind.css'
import { authState, authActions } from './store/auth'

// Create app instance and make it available for event bus functionality
const app = createApp(App);

// Make authentication available globally
app.config.globalProperties.$authState = authState;
app.config.globalProperties.$authActions = authActions;

// Initialize authentication on app start
authActions.initAuth();

// Use router
app.use(router);

// Mount the app
app.mount('#app') 